// extracted by mini-css-extract-plugin
export default {"chevron-wrapper":"spoiler_chevron-wrapper__pSpzb","chevron-root":"spoiler_chevron-root__8yYrN","chevron-icon":"spoiler_chevron-icon__ic5Vt"};